export default "__VITE_ASSET__5ef4817e__"